import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Notis} from '@core/models/user';
import {UserService} from '@core/services/user.service';
import {WebsocketService} from '@core/services/websocket.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationsComponent implements OnInit {

    @Output() clear = new EventEmitter();
    @Input() list: Notis[];

    alertIcon = ['lecturer.user.update', 'student.assignment.test'];
    goodIcon = [
        'student.start.test',
        'student.finish.test',
        'lecturer.start.test',
        'lecturer.finish.test',
    ];
    setsIcon = ['student.share.test',  'lecturer.receiving.test', 'lecturer.sending.test'];
    constructor(private userService: UserService) {
    }

    ngOnInit(): void {
        this.userService.readNotis()
            .subscribe();

    }

    onClear() {
        this.userService.clearNotis()
            .subscribe(() => {
                this.list = [];
                this.clear.emit();
            });

    }

    getIcon(like: string) {
        if (this.alertIcon.includes(like)) {
            return 'alert';
        }
        if (this.goodIcon.includes(like)) {
            return 'good';
        }
        if (this.setsIcon.includes(like)) {
            return 'settings';
        }
    }
}
